import React from 'react';

export const UndoGradient = ({
  className,
  color,
  height,
  width,
}: {
  className?: string;
  color?: string;
  height?: string;
  width?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
  >
    <mask
      id="mask0_1960_31133"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="20"
      height="21"
    >
      <rect y="0.5" width="20" height="20" fill="#EFEEF8" />
    </mask>
    <g mask="url(#mask0_1960_31133)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.33335 4.21582C6.80432 5.30619 5.92372 6.18679 4.83335 6.71582C5.92372 7.24485 6.80432 8.12545 7.33335 9.21582C7.86238 8.12545 8.74298 7.24485 9.83335 6.71582C8.74298 6.18679 7.86238 5.30619 7.33335 4.21582ZM16.3334 11.3826C14.5161 10.5009 13.0484 9.03326 12.1667 7.21597C11.285 9.03326 9.81731 10.5009 8.00003 11.3826C9.81731 12.2644 11.285 13.732 12.1667 15.5493C13.0484 13.732 14.5161 12.2644 16.3334 11.3826ZM4 14.6331C4.90864 14.1922 5.64247 13.4584 6.08333 12.5498C6.52419 13.4584 7.25803 14.1922 8.16667 14.6331C7.25803 15.074 6.52419 15.8078 6.08333 16.7164C5.64247 15.8078 4.90864 15.074 4 14.6331Z"
        fill="url(#paint0_linear_1960_31133)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_1960_31133"
        x1="4.25171"
        y1="4.21582"
        x2="15.6092"
        y2="4.21582"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F54BEA" />
        <stop offset="1" stop-color="#F9975E" />
      </linearGradient>
    </defs>
  </svg>
);
